import { render } from "./InfoUser.vue?vue&type=template&id=426061aa"
import script from "./InfoUser.vue?vue&type=script&lang=js"
export * from "./InfoUser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__